import React from 'react';
import {LeftMenuProps} from './LeftMenu.props';
import './LeftMenu.styles.css';
import AvatarImg  from "../../../assets/img/perfil.png";
import { useNavigate } from 'react-router-dom';

const LeftMenu: React.FC<LeftMenuProps> = () => {
    const navigate = useNavigate();
    // const [activeMenu, setActiveMenu] = useState(false);

    const HandleNavigate = (path:string) => {
        navigate(path);
    }

    return (
        <nav className="sidebar" id="sidebar">
            <div className="sidebar__container">
                <div className="sidebar__user">
                    <div className="sidebar__img">
                        <img src={AvatarImg} alt='avatar'/>
                    </div>
        
                    <div className="sidebar__info">
                        <h3>Kha Hoang</h3>
                        <span>nhoangkha@tma.com.vn</span>
                    </div>
                </div>

                <div className="sidebar__content">
                    <div>
                        <h3 className="sidebar__title">MANAGE</h3>

                        <div className="sidebar__list">
                            <div className={`sidebar__link`} id="launch-job" onClick={(e) => HandleNavigate("/launch-job")}>
                                <i className="ri-pie-chart-2-fill"></i>
                                <span>Launch Jobs</span>
                            </div>
                            
                            {/* <div className="sidebar__link">
                                <i className="ri-wallet-3-fill"></i>
                                <span>My Wallet</span>
                            </div>

                            <div className="sidebar__link">
                                <i className="ri-calendar-fill"></i>
                                <span>Calendar</span>
                            </div>

                            <div className="sidebar__link">
                                <i className="ri-arrow-up-down-line"></i>
                                <span>Recent Transactions</span>
                            </div>

                            <div className="sidebar__link">
                                <i className="ri-bar-chart-box-fill"></i>
                                <span>Statistics</span>
                            </div> */}
                        </div>
                    </div>
                <div>
                    <h3 className="sidebar__title">SETTINGS</h3>

                    <div className="sidebar__list">
                        <div className={`sidebar__link`} id="" onClick={(e) => HandleNavigate("/")}>
                            <i className="ri-settings-3-fill"></i>
                            <span>Settings</span>
                        </div>

                        {/* <div className="sidebar__link">
                            <i className="ri-mail-unread-fill"></i>
                            <span>My Messages</span>
                        </div>

                        <div className="sidebar__link">
                            <i className="ri-notification-2-fill"></i>
                            <span>Notifications</span>
                        </div> */}
                    </div>
                </div>

                <div className="sidebar__actions">
                    <button>
                        <i className="ri-moon-clear-fill sidebar__link sidebar__theme" id="theme-button">
                            <span>Theme</span>
                        </i>
                    </button>

                    <button className="sidebar__link">
                        <i className="ri-logout-box-r-fill"></i>
                        <span>Log Out</span>
                    </button>
                </div>
                </div>
            </div>
        </nav>
    );
};

export default LeftMenu;